import React, { useEffect, useState } from "react";
import {
  getMyPhotos,
  uploadPhoto,
  deletePhoto,
  setMainPhoto
} from "../api/photoApi";

function PhotoManager() {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  async function loadPhotos() {
    try {
      setLoading(true);
      setError("");
      const data = await getMyPhotos();
      setPhotos(data);
    } catch (err) {
      console.error(err);
      setError("Failed to load photos.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadPhotos();
  }, []);

  async function handleFileChange(event) {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
      setError("Only JPG, PNG, and WEBP photos are allowed.");
      event.target.value = "";
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      setError("Photo must be smaller than 10 MB.");
      event.target.value = "";
      return;
    }

    try {
      setUploading(true);
      setError("");

      await uploadPhoto(file);
      await loadPhotos();
    } catch (err) {
      console.error(err);
      setError(err?.response?.data?.message || err?.message || "Photo upload failed.");
    } finally {
      setUploading(false);
      event.target.value = "";
    }
  }

  async function handleDelete(photoId) {
    const confirmed = window.confirm("Delete this photo?");

    if (!confirmed) {
      return;
    }

    try {
      setError("");
      await deletePhoto(photoId);
      await loadPhotos();
    } catch (err) {
      console.error(err);
      setError("Failed to delete photo.");
    }
  }

  async function handleSetMain(photoId) {
    try {
      setError("");
      const updatedPhotos = await setMainPhoto(photoId);
      setPhotos(updatedPhotos);
    } catch (err) {
      console.error(err);
      setError("Failed to set main photo.");
    }
  }

  return (
    <div className="photo-manager">
      <h3>Photos</h3>

      <p className="photo-help-text">
        Upload up to 10 photos. JPG, PNG, and WEBP are supported.
      </p>

      {error && <div className="photo-error">{error}</div>}

      <div className="photo-upload-row">
        <label className="photo-upload-button">
          {uploading ? "Uploading..." : "Upload photo"}
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp"
            onChange={handleFileChange}
            disabled={uploading}
            style={{ display: "none" }}
          />
        </label>
      </div>

      {loading ? (
        <p>Loading photos...</p>
      ) : photos.length === 0 ? (
        <p>No photos uploaded yet.</p>
      ) : (
        <div className="photo-grid">
          {photos.map((photo) => (
            <div key={photo.id} className="photo-card">
              <div className="photo-image-wrapper">
                <img
                  src={photo.url}
                  alt="Profile"
                  className="photo-image"
                />

                {photo.isMain && (
                  <span className="main-photo-badge">Main</span>
                )}
              </div>

              <div className="photo-actions">
                {!photo.isMain && (
                  <button
                    type="button"
                    onClick={() => handleSetMain(photo.id)}
                  >
                    Set main
                  </button>
                )}

                <button
                  type="button"
                  className="danger-button"
                  onClick={() => handleDelete(photo.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PhotoManager;
